export default __webpack_public_path__ + "static/ProValue_2@mob-c11522b90629343b3bdb5fd9d8100ed5.webp";